var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#4C5CF4",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0355 36.0005C49.0363 36.3166 48.9552 36.6276 48.8002 36.9031C48.6452 37.1786 48.4216 37.4093 48.151 37.5728L31.3831 47.8305C31.1004 48.0036 30.7766 48.0981 30.4452 48.1042C30.1137 48.1104 29.7867 48.0279 29.4977 47.8654C29.2116 47.7054 28.9732 47.472 28.8071 47.1894C28.641 46.9067 28.5532 46.5849 28.5527 46.257V25.744C28.5532 25.4161 28.641 25.0943 28.8071 24.8117C28.9732 24.529 29.2116 24.2956 29.4977 24.1356C29.7867 23.9731 30.1137 23.8907 30.4452 23.8968C30.7766 23.9029 31.1004 23.9974 31.3831 24.1706L48.151 34.4282C48.4216 34.5917 48.6452 34.8224 48.8002 35.0979C48.9552 35.3735 49.0363 35.6844 49.0355 36.0005Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/playButton.a9386ca9c2349cdb466e16cc5506dcba.svg";
export { ForwardRef as ReactComponent };